import { CANCELLABLE_STATUSES, NOT_CANCELLABLE_TOOLTIP_COPY } from '../consts';
import CancelOrderModal from './CancelOrderModal';
import { useState } from 'react';
import { Tooltip } from 'tremor/components/Tooltip';

type CancelOrderCellProps = {
  orderUuid: string;
  orderRef: string | null;
  status: string;
};

function CancelOrderCell({ orderUuid, orderRef, status }: CancelOrderCellProps) {
  const [open, setOpen] = useState(false);
  const canCancel = CANCELLABLE_STATUSES.includes(status);

  const cancelButton = (
    <button
      type="button"
      disabled={!canCancel}
      className="text-red-600 text-sm font-medium hover:underline disabled:text-gray-400 disabled:no-underline disabled:cursor-not-allowed"
    >
      Cancel
    </button>
  );

  // Row click opens the details modal — stop the click here so Cancel doesn't also trigger it.
  return (
    <div onClick={(event) => event.stopPropagation()}>
      {canCancel ? (
        <CancelOrderModal orderUuid={orderUuid} orderRef={orderRef} open={open} onOpenChange={setOpen}>
          {cancelButton}
        </CancelOrderModal>
      ) : (
        // Disabled buttons don't receive pointer events, so the tooltip trigger wraps it in a span instead.
        <Tooltip asChild content={NOT_CANCELLABLE_TOOLTIP_COPY[status] ?? 'This order cannot be cancelled.'}>
          <span>{cancelButton}</span>
        </Tooltip>
      )}
    </div>
  );
}

export default CancelOrderCell;
